import ym from 'react-yandex-metrika';

const openLink = (link: string) => {
  ym('openLink', { link });
  window.open(link, '_self');
};

export default openLink;
